import styled from 'styled-components';
import { themes } from 'kb-shared';

export const Container = styled.div`
  ${({ theme }) => theme.grid.pageContainer};
  margin-top: 100px;
`;

export const Title = styled.h1`
  ${({ theme }) => theme.typos.pageHeader};
  margin: 30px 0;
`;

export const DescriptionText = styled.p`
  ${themes.fonts.FoundersGrotesk};
  color: ${themes.colors.KBNight};
  padding-bottom: 12px;
  white-space: pre-wrap;
`;
